<template>
    <div id="dash-root">
        <customer-create-dash-component v-for="(dashpart, index) in dashparts"
                :part="dashpart"
                :key="index">
        </customer-create-dash-component>

        <customer-dash-modal-cancel-booking
                :route_cancel="route_cancel">
        </customer-dash-modal-cancel-booking>

        <customer-dash-modal-prelim-cancellation-info></customer-dash-modal-prelim-cancellation-info>
        <hr>
        <customer-dash-outro></customer-dash-outro>
    </div>
</template>

<script>

    import CustomerDashModalPrelimCancellationInfo from "./CustomerDashModalPrelimCancellationInfo";
    let testdataEmpty = {
        dashparts: [],
    };

    export default {
        name: "customer-dash",
        components: {CustomerDashModalPrelimCancellationInfo},
        props: ['user_id', 'route_book', 'route_settings', 'route_refresh', 'route_cancel', 'route_coupons'],
        data () {
            return JSON.parse(JSON.stringify(testdataEmpty));
        },
        mounted () {
            let self = this; // Hack to get around scope

            axios.get(this.route_refresh)
                .then(function (res) {
                    self.dashparts = res.data;
                })
                .catch(function (error) {
                });
        }
    }
</script>


<style>
    .iframe-size{
        width: 100%;
        height: 300px;
    }
</style>
